import script from "./ProviderView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderView.vue?vue&type=script&setup=true&lang=js"

import "../assets/provider-view.css?vue&type=style&index=0&id=5b50a92f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b50a92f"]])

export default __exports__